import $ from 'jquery';
import View from '../../../controls/View.js';

import Vue from 'vue';
import AdvancedSettingsPage from './ProjectAdvancedSettings.vue';

const ProjectAdvancedSettings = View.extend({

    initialize: function (options) {

        var that = this;

        $('<div id="vue-app">').appendTo(that.$el);

        this.vueApp = new Vue({
            data: {projectId: options.projectId},
            render: function (h) {
                return h(AdvancedSettingsPage, {props: {projectId: this.projectId, bb: that}});
            }
        });

        setTimeout(() => {
            that.vueApp.$mount('#vue-app');
        }, 0);

        return that;

    },

    onFieldChange: function () {
        this._saveNeeded = true;
        return this;
    },

    hasUnsavedChanges: function () {
        return this._saveNeeded;
    },

    remove: function () {

        this.vueApp.$destroy();
        this.constructor.__super__.remove.apply(this, arguments);
    }

});

export default ProjectAdvancedSettings;
